export enum TipoProprietario {
    ETC_EQUIPARADO = 1,
    ETC = 2,
}

export const opcoesTipoProprietarioMapper = [
	{ label: "ETC Equiparado", value: TipoProprietario.ETC_EQUIPARADO },
	{ label: "ETC", value: TipoProprietario.ETC }
];